import ar from './ar';

// ==============================|| I18N ||============================== //
//
// English source strings are the keys: t('Add Captain') returns the Arabic from ./ar.js, or the
// English itself when there's no entry yet (or the language is English) — a missing translation
// shows English, never a raw key or a blank.
//
// The language is read once at startup and switching reloads the page (setLang). That keeps t() a
// plain function, so it works the same in components and in module-level config arrays (menu
// items, ResourcePage columns/fields) without a hook or provider.

const STORAGE_KEY = 'deliveroo-admin-lang';
export const LANGUAGES = [
  { code: 'ar', label: 'العربية' },
  { code: 'en', label: 'English' }
];
const DEFAULT_LANG = 'ar';

function readLang() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return LANGUAGES.some((l) => l.code === stored) ? stored : DEFAULT_LANG;
  } catch {
    return DEFAULT_LANG;
  }
}

export const lang = readLang();
export const isRtl = lang === 'ar';
export const dir = isRtl ? 'rtl' : 'ltr';

document.documentElement.lang = lang;
document.documentElement.dir = dir;

const dictionary = lang === 'ar' ? ar : {};

// Dev aid: untranslated keys seen so far, inspect with `__i18nMissing` in the browser console.
const missing = import.meta.env.DEV ? new Set() : null;
if (missing) window.__i18nMissing = missing;

/**
 * Translate an English UI string. `{name}` placeholders are filled from `vars`:
 *   t('Delete {item}?', { item: t('Captain') })
 * Non-string input (numbers, null, React nodes) is returned untouched, and translating an already
 * translated string is a no-op, so double-wrapping is harmless.
 */
export function t(key, vars) {
  if (typeof key !== 'string') return key;
  let text = dictionary[key];
  if (text === undefined) {
    if (missing && lang !== 'en' && key.trim()) missing.add(key);
    text = key;
  }
  if (vars) text = text.replace(/\{(\w+)\}/g, (match, name) => vars[name] ?? match);
  return text;
}

export function setLang(next) {
  if (next === lang) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, next);
  } catch {
    // storage blocked — nothing to persist, the reload below just keeps the current language
  }
  window.location.reload();
}

// Dates/numbers: Arabic UI with Western digits (ar-EG would switch to Arabic-Indic numerals,
// which is harder to scan for IDs/amounts in an admin table).
export const dateLocale = isRtl ? 'ar-EG-u-nu-latn' : 'en-GB';
